import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBadooComponent } from './simple-icons-badoo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBadooComponent ],
    exports:      [ SimpleIconsBadooComponent ],
    bootstrap:    []
})
export class SimpleIconsBadooModule {}
